import BaseTable from 'react-base-table';
import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
`;

export const StyledSearch = styled.div`
  position: absolute;
  right: 6%;

  .ant-input {
    border-color: #585759 !important;
    position: absolute;
    left: 5px;
    top: 0;
    height: 29px;
    width: 150px;
  }

  .ant-input-affix-wrapper {
    height: 32px;
    position: relative;
  }
`;

export const StyledBaseTable = styled(BaseTable)`
  border: none;
  box-shadow: none;
  font-size: 16px;

  .row-selected {
    background-color: #e9f3fd;
  }

  .row-disabled {
    background-color: #eee;
  }

  .BaseTable__table-main {
    outline: none;

    .BaseTable__header {
      background-color: #fff;
    }
  }

  .BaseTable__table-frozen-left,
  .BaseTable__table-frozen-right {
    box-shadow: none;
  }

  .BaseTable__header-cell-text {
    font-family: Roboto, sans-serif !important;
    font-size: 12px;
    padding-left: 3px;
  }

  .BaseTable__header-row {
    background-color: transparent;
    font-size: 12px;
    line-height: 1.2;
    border-bottom: 1px solid #b0afaf;
    font-weight: 500;
  }

  .BaseTable__column-resizer {
    visibility: visible;
    background-color: #d8e0e6;

    &:hover {
      background-color: #0046ff;
    }
  }

  .BaseTable__row--frozen {
    pointer-events: none;
    font-style: italic;
    font-weight: 500;
  }

  .BaseTable__table-main,
  .BaseTable__table-frozen-left {
    .BaseTable__header-cell:first-child {
      padding-left: 3px;
    }

    .BaseTable__row-cell:first-child {
      padding-left: 3px;
    }
  }

  .BaseTable__row-cell {
    font-size: 14px;
    padding: 0px 3px;
  }

  .BaseTable__table-main .BaseTable__row-cell:last-child {
    padding-right: 3px;
  }

  .BaseTable__header-cell {
    padding: 0 3px;
  }


`;

